var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLicenseDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.283 8.257C7.417 7.343 3.733 7.114 2.542 7c-.109 0-.217 0-.325.114-.109.115-.217.343-.217.457v10.286c0 .343.217.572.542.572h3.25a.592.592 0 0 0 .541-.343c0-.343 1.95-6.4 2.167-9.372 0-.114 0-.343-.217-.457zM19.875 11c-1.083-.343-2.058-.8-2.925-1.143C15 8.943 14.133 9.4 12.4 11.23c-.758.8-1.3 1.942-1.192 2.4 0 .114 0 .114.217.228.542.229 1.3.343 2.058-.914.109-.114.217-.229.434-.229.325 0 .433-.114.758-.228.217-.115.433-.229.758-.343h.217c.108 0 .325.114.433.114.542.572 1.517 1.372 2.492 2.286 1.517 1.257 3.033 2.628 3.792 3.657h.108c-.758-2.286-2.058-6.171-2.6-7.2zM27.458 8.143c-4.225 0-6.608 1.143-6.716 1.143l-.325.343c0 .114 0 .342.108.457.65 1.143 2.817 7.428 3.142 9.028.108.229.325.457.541.457h3.25c.325 0 .542-.228.542-.571V8.714c0-.343-.217-.571-.542-.571z",
    fill: "#4A606A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.608 19.343c-.433-1.029-2.275-2.514-3.9-3.886-.866-.8-1.733-1.486-2.383-2.057-.108.114-.325.114-.325.229-.325.114-.433.228-.867.228-.866 1.143-1.95 1.6-3.141 1.143-.542-.114-.867-.571-.975-1.029-.217-1.142.758-2.742 1.516-3.542H9.367c-.434 2.285-1.192 5.257-1.734 6.857.434.457.867 1.028 1.192 1.257 2.058 1.828 4.442 3.657 4.875 4 .325.228.975.457 1.3.457h.325l-1.733-1.829a.573.573 0 0 1 0-.8.505.505 0 0 1 .758 0l2.167 2.286c.216.229.433.114.65.114.325-.114.433-.342.541-.685l-2.491-2.629a.573.573 0 0 1 0-.8.505.505 0 0 1 .758 0l2.708 2.857c.109.115.542.115.867 0 .108-.114.325-.228.433-.457l-3.033-3.2a.573.573 0 0 1 0-.8.505.505 0 0 1 .758 0l3.142 3.314c.217.115.433 0 .65-.114.108-.114.325-.457.108-.914z",
    fill: "#4A606A",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLicenseDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-license-default.63246520e6c11dd92aab91917b2b9fff.svg";